/**
 * Text menu cards. The same look id is what the frame compositor paints.
 */

import type { TextClipStyle } from '@canvas/shared-types';

export interface TextStyleCard {
  id: string;
  /** Words on the card and the clip it creates. */
  sample: string;
  group: 'plain' | 'style' | 'title';
  /** Hidden until See all. */
  extra?: boolean;
  style: Pick<TextClipStyle, 'fontFamily' | 'fontSize' | 'fontWeight' | 'fill' | 'look' | 'background' | 'bar' | 'inPreset'>;
}

const SANS = 'Montserrat, Arial, sans-serif';

export const TEXT_STYLE_CARDS: TextStyleCard[] = [
  {
    id: 'plain',
    sample: 'Text',
    group: 'plain',
    style: { look: 'plain', fontFamily: SANS, fontSize: 72, fontWeight: 700, fill: '#ffffff', inPreset: 'fade-in' },
  },
  {
    id: 'creator',
    sample: 'CREATOR',
    group: 'style',
    style: { look: 'creator', fontFamily: SANS, fontSize: 64, fontWeight: 800, fill: '#ffffff', inPreset: 'pop-in' },
  },
  {
    id: 'box',
    sample: 'Text box',
    group: 'style',
    style: { look: 'box', fontFamily: SANS, fontSize: 48, fontWeight: 700, fill: '#ffffff', background: '#111111', bar: true, inPreset: 'fade-in' },
  },
  {
    id: 'pride',
    sample: 'Pride',
    group: 'style',
    style: { look: 'pride', fontFamily: SANS, fontSize: 72, fontWeight: 800, fill: '#ffffff', inPreset: 'pop-in' },
  },
  {
    id: 'button',
    sample: 'Button',
    group: 'style',
    style: { look: 'button', fontFamily: SANS, fontSize: 36, fontWeight: 600, fill: '#1c1c1c', background: '#ffffff', bar: true, inPreset: 'fade-in' },
  },
  {
    id: 'bubble',
    sample: 'Bubble',
    group: 'style',
    style: { look: 'bubble', fontFamily: 'Nunito, Comic Sans MS, cursive', fontSize: 68, fontWeight: 800, fill: '#b6ff4a', inPreset: 'pop-in' },
  },
  {
    id: 'retro',
    sample: 'Retro',
    group: 'style',
    style: { look: 'retro', fontFamily: SANS, fontSize: 72, fontWeight: 900, fill: '#161616', inPreset: 'rise' },
  },
  {
    id: 'outline',
    sample: 'Outline',
    group: 'style',
    extra: true,
    style: { look: 'creator', fontFamily: SANS, fontSize: 64, fontWeight: 800, fill: '#111111', inPreset: 'fade-in' },
  },
  {
    id: 'neon',
    sample: 'Neon',
    group: 'style',
    extra: true,
    style: { look: 'bubble', fontFamily: SANS, fontSize: 64, fontWeight: 800, fill: '#7af0ff', inPreset: 'pop-in' },
  },
  {
    id: 'typewriter',
    sample: 'Typewriter',
    group: 'title',
    style: { look: 'typewriter', fontFamily: 'Courier New, Courier, monospace', fontSize: 42, fontWeight: 700, fill: '#ffffff', inPreset: 'none' },
  },
  {
    id: 'circular',
    sample: 'Circular',
    group: 'title',
    style: { look: 'circular', fontFamily: SANS, fontSize: 28, fontWeight: 700, fill: '#ffffff', background: '#3b82f6', inPreset: 'pop-in' },
  },
];

export function textStyleCard(id: string | undefined): TextStyleCard {
  return TEXT_STYLE_CARDS.find((card) => card.id === id) ?? TEXT_STYLE_CARDS[0];
}
